import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'ghost' | 'solid';
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({ children, variant = 'ghost', className = '', ...props }) => {
  const baseStyles = "px-8 py-3 font-roboto text-sm uppercase tracking-[2px] font-medium transition-all duration-300 rounded-md backdrop-blur-sm";
  
  const variants = {
    ghost: "bg-transparent border-2 border-salt-teal text-salt-teal hover:bg-salt-teal hover:text-white hover:shadow-lg hover:-translate-y-0.5",
    solid: "bg-salt-teal border-2 border-salt-teal text-white hover:bg-opacity-90 hover:shadow-lg hover:-translate-y-0.5",
  };

  return (
    <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
};